export default class Buy1click {

    constructor(id, params, result, options) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)
        this.popupId = `${this.id}-basket_buy1click_popup`
        this.$popup = document.getElementById(this.popupId)

        this.init()
    }

    init() {
        this.addObservers()
        this.initJqueryModules()
    }

    reInit() {
        this.$popup = document.getElementById(this.popupId)
        this.initJqueryModules()
    }

    addObservers() {
        this.$component.on('click', '.js-basket-buy1click-opem', () => {
            Fancybox.show(
                [
                    {
                        src: "#basket_buy1click",
                        type: "inline",
                    },
                ],
                {
                    mainClass: 'modal-sale page-basket',
                }
            );

        })

        this.$popup.on('click', '.js-basket-buy1click-order', async () => {
            await this.order()
        })
    }

    initJqueryModules() {
        jQuery(`#${this.id}`).find('.js-basket-buy1click-phone')
            .mask('+7 (000) 000-00-00', {
                onKeyPress: function (cep, event, field, options) {
                    if (cep.indexOf('+8') >= 0) {
                        field.val(cep.replace('+8', '+7')).trigger('keyup');
                    }
                }
            })
    }

    async order() {
        this.showPreloader()

        let ajaxPath = '/ajax/basketD7.php',
            resultData = undefined,
            phone = this.$popup.querySelector('[name="phone"]').value,
            name = this.$popup.querySelector('[name="name"]').value,
            obDefaultPostData = {
                action: 'createFastOrder',
                name: name,
                phone: '',
            }

        obDefaultPostData.phone = phone.replace(/[^\d]/g, '')

        resultData = await Endorphine.Api.query(ajaxPath, obDefaultPostData)

        if (resultData.result) {
            window.location.href = `${this.params.PATH_TO_ORDER}?ORDER_ID=${resultData.order.number}`;
        } else {
            alert(resultData.errorMessage);
            that.ComponentData.labelFastOrder = 'Заказать';
        }

        this.hidePreloader()
    }

    showPreloader() {
        BX.showWait(BX(this.popupId))
    }

    hidePreloader() {
        BX.closeWait(BX(this.popupId))
    }

}
